import { frontendURL } from 'dashboard/helper/URLHelper';
import EstablishmentsIndex from './pages/EstablishmentsIndex.vue';

const establishmentsRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/establishments'),
      name: 'establishments_index',
      meta: {
        permissions: ['administrator', 'agent'],
      },
      component: EstablishmentsIndex,
    },
  ],
};

export default establishmentsRoutes;
